<template>
    <div class="rightContent">
        <div class="rightTitle clear">
            <div class="colorLump"></div>
            <div class="title">修改手机号</div>
        </div>
        <div class="main changePhone">
            <div class="rightBox">
                <el-form :model="query" :rules="queryRules" ref="queryFormRef">
                    <el-form-item label="已绑定手机号：">
                        <div class="el-form-item__content flex">
                            <div class="codeInput el-input flex1">
                                <el-input v-model="query.oldPhone" disabled placeholder="请输入联系人手机号" />
                            </div>
                            <button type="button" class="el-button codeButton el-button--primary"
                                @click="oldSendVerifyCode()" v-if="!oldVerifyCode.waiting">
                                <span>获取验证码</span>
                            </button>
                            <button type="button" class="el-button codeButton el-button--primary"
                                v-if="oldVerifyCode.waiting">
                                <span>重新发送{{ oldVerifyCode.countDown }}s</span>
                            </button>
                        </div>
                    </el-form-item>
                    <el-form-item label="验证码" required prop="oldCode">
                        <el-input v-model="query.oldCode" placeholder="请输入已绑定手机号验证码" />
                    </el-form-item>
                    <el-form-item label="新手机号：" required prop="phone">
                        <div class="el-form-item__content flex">
                            <div class="codeInput el-input flex1">
                                <el-input v-model="query.phone" placeholder="请输入联系人手机号" />
                            </div>
                            <button type="button" class="el-button codeButton el-button--primary"
                                @click="sendVerifyCode()" v-if="!verifyCode.waiting">
                                <span>获取验证码</span>
                            </button>
                            <button type="button" class="el-button codeButton el-button--primary"
                                v-if="verifyCode.waiting">
                                <span>重新发送{{ verifyCode.countDown }}s</span>
                            </button>
                        </div>
                    </el-form-item>
                    <el-form-item label="验证码" required prop="code">
                        <el-input v-model="query.code" placeholder="请输入已绑定手机号验证码" />
                    </el-form-item>
                    <div class="save" @click="updataPhone(queryFormRef)">  保存 </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script setup>
    import { useRoute,useRouter } from "vue-router";
    import { ref, reactive,getCurrentInstance } from 'vue'
    import {getVerifyCode } from "../../server/jigou/org";
    import { orgUpdatePhone } from "../../server/jigou/orgCenter"
    
    const { proxy } = getCurrentInstance()
    const query = reactive({
        oldPhone:'',
        oldCode:'',
        phone:'',
        code:''
    })
    const queryFormRef = ref()
    const equalToTel = (rule, value, callback) => {
    if (query.oldPhone == value) {
      callback(new Error("新手机号与旧手机号一致"));
      return
    } else {
      callback();
    }
  };
  
    const queryRules = reactive({
        oldCode: [{ required: true, message: '请输入旧手机验证码', trigger: "blur" }],
        phone: [{ required: true, trigger: "blur", message: "请输入您的新手机号" }, { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: "请输入正确的手机号码", trigger: "blur" }, { required: true, validator: equalToTel, trigger: "blur" }],
        code: [{ required: true, message: '请输入新手机验证码', trigger: "blur" }],
    })
    const oldVerifyCode = reactive({
        waiting: false,
        countDown: 60,
        countDownTimer: ''
    })
    const verifyCode = reactive({
        waiting: false,
        countDown: 60,
        countDownTimer: ''
    })
    const router = useRoute();
    const tel = ref('')
    query.oldPhone = router.query.tel
    const router1 = useRouter()

    // 获取旧手机号验证码
    function oldSendVerifyCode() {
        if (oldVerifyCode.waiting) {
            // 等待倒计时结束
            return;
        }
        if (query.oldPhone.length == 0) {
            alert("联系人手机号不能为空");
        } else {
            getVerifyCode(query.oldPhone);
            oldVerifyCode.waiting = true;
            oldVerifyCode.countDown = 60;
            oldVerifyCode.countDownTimer = setInterval(() => {
                oldVerifyCode.countDown -= 1;
                if (oldVerifyCode.countDown <= 0) {
                    // 清除倒计时Timer
                    clearInterval(oldVerifyCode.countDownTimer);
                    // 重置参数
                    oldVerifyCode.waiting = false;
                }
            }, 1000);
        }
    }
    // 获取新手机号验证码
    function sendVerifyCode() {
        if (verifyCode.waiting) {
            // 等待倒计时结束
            return;
        }
        if (query.phone.length == 0) {
            alert("联系人手机号不能为空");
        } else {
            getVerifyCode(query.phone);
            verifyCode.waiting = true;
            verifyCode.countDown = 60;
            verifyCode.countDownTimer = setInterval(() => {
                verifyCode.countDown -= 1;
                if (verifyCode.countDown <= 0) {
                    // 清除倒计时Timer
                    clearInterval(verifyCode.countDownTimer);
                    // 重置参数
                    verifyCode.waiting = false;
                }
            }, 1000);
        }
    }

    async function updataPhone(formEl){
        formEl.validate(async (valid, fields) => {
            if (!valid) {
                return;
            }
        })
        let res = await orgUpdatePhone(query)
        if( res != false ){
            proxy.$modal.msgSuccess("手机号修改成功");
            router1.push({path:'jbxx'})
        }
        
    }
</script>
<style scoped>
.codeInput,.el-input{
    width: 200px;
}
.el-form-item >>>.el-form-item__label{
    width: 120px !important;justify-content: flex-start;
}
</style>